import createNavTrackingClient from './createNavTrackingClient';
import { Logger } from 'simple-logging-lib';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../../constants/logging';
import { isJasmineRunning } from '../../utils/testEnv';
import { waitForBoolean } from 'navigation-components/common/utils';
let NavUsageTracker;
let NavUsageTrackerStandalone;
function setupNavUsageTrackers(userEmail, navType) {
  if (NavUsageTracker) return;
  const usageTrackingClient = createNavTrackingClient(userEmail);

  // For events that won't trigger a page unload
  NavUsageTracker = usageTrackingClient.createTracker({
    standalone: true,
    properties: {
      namespace: 'nav-v4',
      navType
    },
    bypassPool: false
  });
  NavUsageTrackerStandalone = NavUsageTracker.clone({
    standalone: true
  });
}
const trackingFallback = (namespace, eventName, properties) => {
  if (isJasmineRunning()) {
    return;
  }
  const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
  logger.error(new Error('NavUsageTracker not initialized'), {
    extra: {
      namespace,
      eventName,
      properties
    }
  });
};
function trackUsage(eventName, properties, {
  isStandalone,
  isRetry,
  namespace
} = {
  isStandalone: true,
  isRetry: false,
  namespace: 'nav-v4'
}) {
  if (!NavUsageTracker || !NavUsageTrackerStandalone) {
    if (isRetry) {
      trackingFallback(namespace, eventName, properties);
      return;
    }

    // If the tracker is not initialized, wait for it to be initialized and then track the event
    waitForBoolean(() => !!NavUsageTracker && !!NavUsageTrackerStandalone).then(() => {
      trackUsage(eventName, properties, {
        isRetry,
        isStandalone,
        namespace
      });
    }).catch(() => trackingFallback(namespace, eventName, properties));
    return;
  }
  if (isStandalone) {
    NavUsageTrackerStandalone.track(namespace, eventName, properties);
  } else {
    NavUsageTracker.track(eventName, properties);
  }
}
function resetTrackerForTests() {
  NavUsageTracker = undefined;
}
export { setupNavUsageTrackers, trackUsage, resetTrackerForTests };